// API Configuration
// Change this to your backend URL
// For local development: 'http://localhost:8000'
// For production: 'http://194.156.66.98:8032'

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
